import { render } from "./practice-people-signatories.html?vue&type=template&id=6c191fd8&scoped=true&ts=true&external"
import script from "./practice-people-signatories.ts?vue&type=script&lang=ts&external"
export * from "./practice-people-signatories.ts?vue&type=script&lang=ts&external"

import "./practice-people-signatories.scss?vue&type=style&index=0&id=6c191fd8&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c191fd8"]])

export default __exports__